module.exports = __webpack_public_path__ + "static/media/works_factful-bubble-chart.ce52e0af.png";